import { States } from 'safe'
import {
  MovementTypes,
  SET_MOVEMENTS,
} from '../actions/actionTypes'

export const initialState: States.Movements = {
  movements: [],
  numberOfPages: 0,
}

//eslint-disable-next-line
export default (
  state = initialState,
  action: MovementTypes
): States.Movements => {
  switch (action.type) {
    case SET_MOVEMENTS:
      return {movements: action?.payload?.movements, numberOfPages: action?.payload?.numberOfPages}
    default:
      return state
  }
}